import React, { useEffect } from 'react';
import { Typography } from '@mui/material';
import errorImage from '@ed/baseline/images/library-illustrations/404-sm.png';
import logErrorWithContext from '@hmhco/client-monitoring/src/context/logErrorWithContext';
import { useLocation } from 'react-router-dom';
import useStyles from './Error.styles';

const Error = () => {
  const { classes } = useStyles();

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const {
    error_code: errorCode,
    error,
    error_description: errorDescription,
    date,
    state,
    username,
    trace_id: traceId,
  } = Object.fromEntries(params.entries());

  useEffect(() => {
    logErrorWithContext(`Login error ${errorCode}`, [
      { key: 'errorCode', value: errorCode },
      { key: 'error', value: error },
      { key: 'errorDescription', value: errorDescription },
      { key: 'date', value: date },
      { key: 'state', value: state },
      { key: 'username', value: username },
      { key: 'traceId', value: traceId },
    ]);
  }, []);

  return (
    <div className={classes.root}>
      <Typography variant="h1" className={classes.heading}>
        Oops something went wrong!
      </Typography>
      <div className={classes.main}>
        <div className={classes.content}>
          <Typography
            variant="h4"
            component="p"
            className={classes.userFriendlyError}
          >
            An unexpected error occurred, please wait a few moments and try
            again. If you still get this error, contact your account&apos;s
            administrator or customer support to fix it.
          </Typography>
          {username && (
            <Typography variant="h4" className={classes.text}>
              Username: {username}
            </Typography>
          )}
          {errorCode && (
            <Typography variant="h4" component="p" className={classes.text}>
              Error Code: {errorCode}
            </Typography>
          )}
          {error && (
            <Typography variant="h4" component="p" className={classes.text}>
              Error: {error}
            </Typography>
          )}
          {date && (
            <Typography variant="h4" component="p" className={classes.text}>
              Date: {date}
            </Typography>
          )}
          {traceId && (
            <Typography variant="h4" component="p" className={classes.text}>
              Trace ID: {traceId}
            </Typography>
          )}
          {errorDescription && (
            <Typography variant="h4" component="p" className={classes.text}>
              Error Description: {errorDescription}
            </Typography>
          )}
        </div>
        <div className={classes.imageContainer}>
          <img className={classes.image} src={errorImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Error;
